import script from "./SiteFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteFooter.vue?vue&type=script&setup=true&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=6820cd29&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6820cd29"]])

export default __exports__